"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const FieldsSetupFlowController_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/controllers/FieldsSetupFlowController"));
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const StepHeader_vue_1 = __importDefault(require("../components/StepHeader.vue"));
const StepFooter_vue_1 = __importDefault(require("../components/StepFooter.vue"));
const Field_1 = __importDefault(require("../modules/models/Field"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const Utils_1 = require("@becrop/components/Map/Utils");
const Vector_1 = __importDefault(require("ol/source/Vector"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Vector_2 = __importDefault(require("ol/layer/Vector"));
const lucide_vue_next_1 = require("lucide-vue-next");
const Loader_vue_1 = __importDefault(require("./Loader.vue"));
const VardaHelp_vue_1 = __importDefault(require("../components/modals/VardaHelp.vue"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const extent_1 = require("ol/extent");
const olSphere = __importStar(require("ol/sphere"));
const proj_1 = require("ol/proj");
const DrawBuilder_1 = __importDefault(require("@becrop/components/Map/ModelsT/DrawBuilder"));
const Draw_1 = __importDefault(require("ol/interaction/Draw"));
const Style_1 = __importDefault(require("ol/style/Style"));
const Fill_1 = __importDefault(require("ol/style/Fill"));
const Stroke_1 = __importDefault(require("ol/style/Stroke"));
const Circle_1 = __importDefault(require("ol/style/Circle"));
const format_1 = require("ol/format");
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const VueToastify_vue_1 = __importDefault(require("@becrop/components/VueToastify/VueToastify.vue"));
let VardaViewStep = class VardaViewStep extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.vardaStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.BEFORE_STEP = this.MAIN_CONTROLLER.workflowStep;
        this.MAP_CONTROLLER = new Controller_1.default();
        this.MAP_ID = 'varda-map-container';
        this.fields_wkt = [];
        this.searchString = '';
        this.drawFieldsAction = false;
        this.loading = false;
        this.showVardaHelpAlert = false;
        this.vueToastId = 0;
        // BLOCK ADDED TO SHORTEN THE VARDA PATH FOR ADDING FIELDS
        this.loadingNextView = false;
        this.displayModal = false;
        this.modalContent = {
            type: '',
            response: '',
            warnings: []
        };
        this.extensionLimits = {
            field: {
                min_ha: '0.0001 ha',
                min_ac: '0.00025 ac',
                max_ha: '500 ha',
                max_ac: '1235.53 ac'
            },
            farm: {
                max_ha: '3500 ha',
                max_ac: '8648.69 ac'
            }
        };
        this.numFarmsCreated = 0;
        this.MAX_DISTANCE_KM = 25;
        this.drawBuilder = new DrawBuilder_1.default(this.MAP_CONTROLLER.map);
        this.temporalFields = [];
        this.countAlertZoom = false;
    }
    // END OF ADDITIONAL CODE TO SHORTEN VARDA PATH
    triggerToast(msg, theme = 'info', time = 10000) {
        const toast = this.$refs.toastComponent;
        this.vueToastId += 1;
        toast.showToast(this.vueToastId, msg, time, theme);
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 45, 45);
    }
    removeField(fieldId) {
        this.MAP_CONTROLLER.restoreSelectedFeaturesStyles(`${fieldId}`);
    }
    search(f) {
        this.searchString = f;
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    async centerZone(extent, padding) {
        await (0, CenterUtility_1.center)(this.MAP_CONTROLLER.map, extent, 700, padding);
    }
    async focusField(field) {
        const feature = new format_1.WKT().readFeature(field.geodata, this.projections);
        const geometry = feature.getGeometry();
        this.MAP_CONTROLLER.map.getView().setZoom(15);
        this.centerZone(geometry.getExtent(), [100, 100, 100, 100]);
    }
    sizeTotalFields() {
        const data = this.STEP_CONTROLLER.data.selectedFields;
        const totalSize = data.reduce((sum, item) => sum + item.size, 0);
        const sizeUnit = data.length > 0 ? data[0].sizeUnit : "";
        if (totalSize === 0)
            return '';
        else
            return `${totalSize.toFixed(2)} ${sizeUnit}`;
    }
    drawFieldInMapPaint() {
        this.drawFieldsAction = true;
        const mapOl = this.MAP_CONTROLLER.map;
        mapOl.getViewport().style.cursor = 'url(/images/map/resources/pen-tool.svg) 0 -10, auto';
        const vectorSource = new Vector_1.default();
        const vectorLayer = new Vector_2.default({ source: vectorSource });
        mapOl.addLayer(vectorLayer);
        vectorLayer.set('id', 'draw-polygon-layer');
        const pointsStyle = new Circle_1.default({
            radius: 6,
            fill: new Fill_1.default({
                color: '#eebb54',
            }),
            stroke: new Stroke_1.default({
                color: '#fff',
                width: 3,
            }),
        });
        const style = new Style_1.default({
            fill: new Fill_1.default({
                color: '#2a734650',
            }),
            stroke: new Stroke_1.default({
                color: '#2a7346',
                width: 3,
            }),
            image: pointsStyle,
        });
        const drawInteraction = new Draw_1.default({
            source: vectorSource,
            type: 'Polygon',
            style: style
        });
        mapOl.addInteraction(drawInteraction);
        drawInteraction.on('drawstart', (event) => {
            mapOl.getViewport().style.cursor = 'url(/images/map/resources/pen-tool.svg) 0 -10, auto';
            this.MAP_CONTROLLER.drawInteraction = true;
            this.MAP_CONTROLLER.map.unset('pointermove');
            this.MAP_CONTROLLER.map.unset('singleclick');
        });
        drawInteraction.on('drawend', async (event) => {
            const feature = event.feature;
            const geometry = feature.getGeometry();
            const coordinates = geometry.getCoordinates();
            drawInteraction.setActive(false);
            const geometryExtent = geometry.getExtent();
            const center = (0, extent_1.getCenter)(geometryExtent);
            const area = olSphere.getArea(geometry);
            const hectares = area / 10000;
            const transformedCoordinates = geometry
                .getCoordinates()
                .map((ring) => ring.map((coord) => (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326')));
            const geodata = `POLYGON(${transformedCoordinates
                .map((ring) => `(${ring.map((coord) => coord.join(' ')).join(',')})`)
                .join(', ')})`;
            const idField = this.STEP_CONTROLLER.data.fields.length;
            const fieldToAdd = new Field_1.default({
                id: idField,
                gfId: -1,
                fieldName: `${idField}`,
                farmId: 0,
                farmName: '',
                size: hectares,
                sizeUnit: 'hectares',
                managementPractice: null,
                crop: new Crop_1.default({
                    id: -1,
                    name: '-',
                    color: '#eebb54',
                    icon: '-'
                }),
                geodata: geodata,
                origin: '',
                metadata: [],
                projection: '',
                ebecrop: false,
                quoteId: -1,
                provider: 'setup-drawn',
                providerFieldId: ''
            });
            this.STEP_CONTROLLER.data.fields.push(fieldToAdd);
            this.temporalFields.push(fieldToAdd);
            //this.MAP_CONTROLLER.selectedFeaturesFields.push(feature);
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: geodata,
                fillColor: '#85df4f30',
                strokeColor: '#85df4f',
                strokeWidth: 2,
                enableHoverInteraction: true,
                enableSelectInteraction: true,
                zoneName: `${idField}`,
                centerZone: false,
                avg: 0,
                markers: [],
                preciseResult: false,
                modifyInteraction: false
            }), 700, [50, 50, 50, 50]);
            this.drawFieldsAction = false;
            this.MAP_CONTROLLER.drawInteraction = false;
            mapOl.getViewport().style.cursor = '';
        });
        (0, Utils_1.removeLayerById)('draw-polygon-layer', this.MAP_CONTROLLER.map);
        (0, Utils_1.removeLayerById)('draw-points-layer', this.MAP_CONTROLLER.map);
    }
    get finishDrawInteraction() {
        return this.MAP_CONTROLLER.drawBuilder.finishDrawInteraction;
    }
    onSearchChange(f) {
        if (f.length > 0) {
            const isValidCoordinates = this.validateCoordinates(f);
            if (isValidCoordinates) {
                this.MAP_CONTROLLER.searchLocation(f);
                this.MAP_CONTROLLER.map.getView().setZoom(16);
                this.updateFields();
            }
            else {
                this.triggerToast('Coordenadas inválidas. Asegúrate de usar el formato correcto: lat, lon.', 'error');
            }
        }
    }
    validateCoordinates(coordinateString) {
        const coordinates = coordinateString.split(/[^-0-9.]+/).map(coord => coord.trim()).filter(coord => coord !== '');
        if (coordinates.length !== 2) {
            return false;
        }
        const [lat, lon] = coordinates.map(Number);
        if (isNaN(lat) || isNaN(lon)) {
            return false;
        }
        if (lat < -90 || lat > 90 || lon < -180 || lon > 180) {
            return false;
        }
        return true;
    }
    /*  removeSelected() {
         this.MAP_CONTROLLER.restoreSelectedFeaturesStyles();
     } */
    removeFeaturesNotInView() {
        const mapExtent = this.MAP_CONTROLLER.map.getView().calculateExtent(); // Extensión del área visible
        const layer = (0, Utils_1.findLayerById)('zone-layer', this.MAP_CONTROLLER.map); // Reemplaza con el nombre de tu capa
        if (layer) {
            const source = layer.getSource();
            const features = source.getFeatures();
            features.forEach((feature) => {
                const geometry = feature.getGeometry();
                if (!geometry.intersectsExtent(mapExtent) && !this.MAP_CONTROLLER.selectedFeaturesFields.includes(feature)) {
                    source.removeFeature(feature); // Elimina la feature si no está en el área visible
                }
            });
        }
    }
    currentMapZoom() {
        if (this.MAP_CONTROLLER.currentZoom < 15 && !this.countAlertZoom) {
            this.triggerToast('Please focus on the area of interest or search for coordinates through the search engine', 'info', 20000);
            this.countAlertZoom = true;
        }
    }
    async updateFields() {
        if (this.MAP_CONTROLLER.currentZoom >= 15) {
            this.loading = true;
            this.STEP_CONTROLLER.data.fields.forEach(ff => { this.temporalFields.push(ff); });
            this.STEP_CONTROLLER.data.fields = [];
            for (const element of this.MAP_CONTROLLER.lastCoordinatesUrl) {
                await this.STEP_CONTROLLER.getVardaFields(element);
                this.drawFieldInMap();
            }
            this.loading = false;
        }
    }
    get mapSelectedFeaturesFields() {
        return this.MAP_CONTROLLER.selectedFeaturesFields;
    }
    updateSelectedFieldInMap() {
        const fields = [];
        this.MAP_CONTROLLER.selectedFeaturesFields.forEach((feature) => {
            // Buscar el field correspondiente al feature
            const fieldToAdd = this.temporalFields.find((field) => `${field.geodata}` === feature.get('geodata'));
            if (fieldToAdd) { // Verifica que no sea undefined
                if (this.MAIN_CONTROLLER.isAddingFields) {
                    fieldToAdd.evaluateFieldDistance(this.MAIN_CONTROLLER.editFarmGeodata);
                    fieldToAdd.farmName = this.MAIN_CONTROLLER.farmToAddFields;
                }
                fields.push(fieldToAdd);
            }
        });
        this.STEP_CONTROLLER.data.selectedFields = fields;
    }
    async mounted() {
        this.showVardaHelpAlert = true;
        this.MAP_CONTROLLER.create(this.MAP_ID, this.mapConfig.provider, this.mapConfig.apikey, '', '', '', 15, 5, 17);
        this.MAP_CONTROLLER.addSelectMultiInteractions();
        this.MAP_CONTROLLER.applyDrawBox();
        (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
        await this.updateFields();
        this.drawFieldInMap();
        if (this.MAIN_CONTROLLER.isAddingFields) {
            const coordinates = this.MAIN_CONTROLLER.parseGeodataToCoordinates;
            this.onSearchChange(`${coordinates[1]}, ${coordinates[0]}`);
        }
        else {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    this.searchString = latitude + ", " + longitude;
                    this.onSearchChange(latitude + ", " + longitude);
                });
            }
            else {
                this.searchString = `${this.data.userLocation.lat},  ${this.data.userLocation.lon}`;
                this.onSearchChange(`${this.data.userLocation.lat},  ${this.data.userLocation.lon}`);
            }
        }
    }
    // METHODS ADDED TO SHORTEN VARDA
    getWarningValues(obj, values = []) {
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                this.getWarningValues(obj[key], values);
            }
            else if (typeof obj[key] === 'string') {
                values.push(obj[key]);
            }
        }
        return values;
    }
    processResponse(response) {
        this.modalContent.warnings = [];
        if (response.status === 200) {
            this.modalContent.type = 'ok';
            this.modalContent.response = response.messages;
            this.modalContent.warnings = this.getWarningValues(response.ignored);
            this.numFarmsCreated = !isNaN(response.created) ? parseInt(response.created) : 0;
        }
        else {
            this.modalContent.type = 'error';
            if (response.type === 'error' && response.messages !== undefined) {
                this.modalContent.response = response.messages;
            }
            else {
                this.modalContent.response = this.$trans('setup_activation.responses.error.unexpected_error_has_occurred');
            }
        }
    }
    goToFarmsList() {
        if (this.MAIN_CONTROLLER.isAddingFields) {
            window.location.href = `/farm/${this.MAIN_CONTROLLER.farmIdToAddFieldsTo}/edit`;
        }
        else {
            window.location.href = `/farm/list?just_created=true&new_farms=${this.numFarmsCreated}`;
        }
    }
    // END OF ADDED METHODS
    async nextStep() {
        if (this.MAIN_CONTROLLER.isAddingFields) {
            this.loadingNextView = true;
            this.STEP_CONTROLLER.setFarmNameToAllFields(this.MAIN_CONTROLLER.farmToAddFields);
            this.STEP_CONTROLLER.setCropToAllFields(this.MAIN_CONTROLLER.crop);
            const FINAL_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsSummaryStep;
            FINAL_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.selectedFields);
            const response = await FINAL_STEP_CONTROLLER.sendFields();
            this.processResponse(response);
            this.displayModal = true;
            this.loadingNextView = false;
        }
        else {
            this.NEXT_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.selectedFields);
            this.MAIN_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
            this.STEP_CONTROLLER.resetStep();
            let mode = (this.MAIN_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
            this.MAIN_CONTROLLER.logActivity({
                'name': `Farm ${mode} Step 2 Completed: Field Selection`,
                'status': 'ok',
                'props': {
                    'workflow': 'varda'
                }
            });
        }
    }
    beforeStep() {
        this.STEP_CONTROLLER.resetStep();
        this.NEXT_STEP_CONTROLLER.resetStep();
        this.MAIN_CONTROLLER.setCurrentStep(this.BEFORE_STEP);
    }
    async drawFieldInMap() {
        this.STEP_CONTROLLER.data.fields.forEach(ff => { this.temporalFields.push(ff); });
        this.STEP_CONTROLLER.data.fields.forEach((field) => {
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: field.geodata,
                fillColor: '#85df4f30',
                strokeColor: '#85df4f',
                strokeWidth: 2,
                enableHoverInteraction: true,
                enableSelectInteraction: true,
                zoneName: `${field.id}`,
                centerZone: false,
                avg: 0,
                markers: [],
                preciseResult: false,
                modifyInteraction: false
            }), 700, [50, 50, 50, 50]);
        });
        this.removeFeaturesNotInView();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VardaViewStep.prototype, "mapConfig", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VardaViewStep.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.currentZoom')
], VardaViewStep.prototype, "currentMapZoom", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.lastCoordinatesUrl')
], VardaViewStep.prototype, "updateFields", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.selectedFeaturesFields', { deep: true })
], VardaViewStep.prototype, "updateSelectedFieldInMap", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('STEP_CONTROLLER.data.fields')
], VardaViewStep.prototype, "drawFieldInMap", null);
VardaViewStep = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StepHeader: StepHeader_vue_1.default, StepFooter: StepFooter_vue_1.default, Button: bmk_ui_framework_1.Button, Search: bmk_ui_framework_1.Search, MapAttributions: bmk_ui_framework_1.MapAttributions, Plus: lucide_vue_next_1.Plus, Minus: lucide_vue_next_1.Minus, PenTool: lucide_vue_next_1.PenTool, Expand: lucide_vue_next_1.Expand, Loader: Loader_vue_1.default, VardaHelp: VardaHelp_vue_1.default, Trash2: lucide_vue_next_1.Trash2, LassoSelect: lucide_vue_next_1.LassoSelect, Separator: bmk_ui_framework_1.Separator, MapPin: lucide_vue_next_1.MapPin, VueToastify: VueToastify_vue_1.default, Modal: bmk_ui_framework_1.Modal, CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon, WarningTriangledIcon: bmk_ui_framework_1.WarningTriangledIcon, XAloneIcon: bmk_ui_framework_1.XAloneIcon, AlertTriangle: lucide_vue_next_1.AlertTriangle
        }
    })
], VardaViewStep);
exports.default = VardaViewStep;
